import React from 'react';

/**
 * Agent Runs Help Content
 */
const RunsHelp: React.FC = () => {
  return (
    <>
      <div>
        <h3 className="text-base font-semibold text-gray-900 dark:text-white mb-2">
          Agent Runs
        </h3>
        <p className="text-sm text-gray-600 dark:text-gray-400 leading-relaxed">
          The Runs page displays all agent executions in your system. Each run represents a complete agent workflow from start to finish, including all tool calls and decisions made.
        </p>
      </div>

      <div>
        <h3 className="text-base font-semibold text-gray-900 dark:text-white mb-2">
          Run Information
        </h3>
        <div className="space-y-2 text-sm text-gray-600 dark:text-gray-400">
          <p>&#8226; <span className="font-medium">Run ID</span>: Unique identifier for the execution</p>
          <p>&#8226; <span className="font-medium">Agent</span>: The agent that was executed</p>
          <p>&#8226; <span className="font-medium">Status</span>: Success, error, timeout, or in-progress</p>
          <p>&#8226; <span className="font-medium">Duration</span>: Total execution time</p>
          <p>&#8226; <span className="font-medium">Steps</span>: Number of agent steps taken</p>
          <p>&#8226; <span className="font-medium">Tools</span>: Tools invoked during execution</p>
          <p>&#8226; <span className="font-medium">Tokens/Cost</span>: Resource consumption</p>
        </div>
      </div>

      <div>
        <h3 className="text-base font-semibold text-gray-900 dark:text-white mb-2">
          Run Outcomes
        </h3>
        <div className="space-y-2 text-sm text-gray-600 dark:text-gray-400">
          <p>&#8226; <span className="font-medium text-green-600 dark:text-green-400">Success</span>: Agent completed task successfully</p>
          <p>&#8226; <span className="font-medium text-red-600 dark:text-red-400">Error</span>: Agent encountered an unrecoverable error</p>
          <p>&#8226; <span className="font-medium text-yellow-600 dark:text-yellow-400">Timeout</span>: Execution exceeded time limit</p>
          <p>&#8226; <span className="font-medium text-orange-600 dark:text-orange-400">Partial Success</span>: Completed with some failures</p>
          <p>&#8226; <span className="font-medium text-gray-600 dark:text-gray-400">Cancelled</span>: Manually stopped</p>
        </div>
      </div>

      <div>
        <h3 className="text-base font-semibold text-gray-900 dark:text-white mb-2">
          Filtering Runs
        </h3>
        <p className="text-sm text-gray-600 dark:text-gray-400 leading-relaxed mb-3">
          Use filters to find specific runs:
        </p>
        <div className="space-y-2 text-sm text-gray-600 dark:text-gray-400">
          <p>&#8226; Filter by agent name</p>
          <p>&#8226; Filter by status (success, error, etc.)</p>
          <p>&#8226; Filter by user ID or session ID</p>
          <p>&#8226; Search by run ID</p>
          <p>&#8226; Select date range</p>
        </div>
      </div>

      <div>
        <h3 className="text-base font-semibold text-gray-900 dark:text-white mb-2">
          Run Details
        </h3>
        <p className="text-sm text-gray-600 dark:text-gray-400 leading-relaxed">
          Click on any run to view the complete execution trace, including step-by-step agent reasoning, tool inputs/outputs, and timing breakdowns.
        </p>
      </div>

    </>
  );
};

export default RunsHelp;
